import { ReactElement, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';

import { Button, Div, Divider, Flex, Gutter, Logo, OverflowMenu, Title } from '@gaiads/telia-react-component-library';

import { HIDDEN_PAGE_PATHS } from '../../../../utils';
import { isReportAccessForbidden } from '../utils';

export interface PageTemplateTranslations {
  title: string;
}

export interface PageTemplateProps {
  translations: PageTemplateTranslations;
  pageContent: ReactElement;
}

export default function PageTemplate(props: PageTemplateProps) {
  const [open, setOpen] = useState(false);

  const { t } = useTranslation('backOffice');
  const history = useHistory();

  const { accounts } = useMsal();

  return (
    <Div backgroundColor="purple500" style={{ height: 'auto', minHeight: '100%' }} padding={{ size: 'xxlg' }}>
      <Div backgroundColor="white" padding={{ size: 'xlg' }} borderRadius={{ size: 'md' }}>
        <Flex spaceBetween>
          <Logo size="lg" color="purple500" />
          <Button margin={{ right: 'md' }} variant="secondary" onClick={() => history.push('/')}>
            {t('common.toFrontPageButton')}
          </Button>
        </Flex>
        <Gutter />
        <Flex spaceBetween>
          <Title tagName="h2" size="sm" color="gray500">
            {`${t('common.title')} - ${props.translations.title}`}
          </Title>
          <OverflowMenu onClick={() => setOpen(!open)} open={open}>
            <OverflowMenu.Item
              onClick={() => history.push(HIDDEN_PAGE_PATHS.orders)}
              iconName="delivery"
              label={t('ordersPage.menuItemLabel')}
              variant={window.location.pathname === HIDDEN_PAGE_PATHS.orders ? 'disabled' : 'active'}
            />
            <OverflowMenu.Item
              onClick={() => history.push(HIDDEN_PAGE_PATHS.returnPackageOrders)}
              iconName="phone-recycling"
              label={t('returnPackageOrdersPage.menuItemLabel')}
              variant={window.location.pathname === HIDDEN_PAGE_PATHS.returnPackageOrders ? 'disabled' : 'active'}
            />
            <Divider />
            <OverflowMenu.Item
              onClick={() => history.push(HIDDEN_PAGE_PATHS.devices)}
              iconName="smartphone"
              label={t('devicesPage.menuItemLabel')}
              variant={window.location.pathname === HIDDEN_PAGE_PATHS.devices ? 'disabled' : 'active'}
            />
            <Divider />
            <OverflowMenu.Item
              onClick={() => history.push(HIDDEN_PAGE_PATHS.availability)}
              iconName="offering"
              label={t('availabilityPage.menuItemLabel')}
              variant={window.location.pathname === HIDDEN_PAGE_PATHS.availability ? 'disabled' : 'active'}
            />
            <Divider />
            <OverflowMenu.Item
              onClick={() => history.push(HIDDEN_PAGE_PATHS.reports)}
              iconName="report"
              label={t('reportsPage.menuItemLabel')}
              variant={window.location.pathname === HIDDEN_PAGE_PATHS.reports ? 'disabled' : 'active'}
              hidden={isReportAccessForbidden(accounts)}
            />
          </OverflowMenu>
        </Flex>
        <Gutter size="xlg" />
        <>{props.pageContent}</>
      </Div>
    </Div>
  );
}
